import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const animatedXInit = () => {
  const modules = document.querySelectorAll('.gg-animated-x');
  modules.forEach((module) => {
    const contents = module.querySelectorAll('.gg-animated-x-column__content');
    const images = module.querySelectorAll('.gg-animated-x-column__image');

    contents.forEach((content, index) => {
      const correspondingImage = images[index];

      if (content && correspondingImage) {
        content.addEventListener('mouseenter', () => {
          correspondingImage.classList.add('hovering');
        });

        content.addEventListener('mouseleave', () => {
          correspondingImage.classList.remove('hovering');
        });
      }
    });
  });
};

Gravity.ready(animatedXInit);
